// extracted by mini-css-extract-plugin
export default {"Emojify":"bbj_a bhj_g"};